import { useRef, useContext } from "react"
import Header from "../../../layouts/Header"
import BackIcon from "../../../components/BackIcon"
import { useNavigate, useLocation } from "react-router-dom"
import { Box, Tooltip, IconButton } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import esLocale from "date-fns/locale/es"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { useMutation, api } from "../../../api"
import { GlobalContext } from "../../../contexts/GlobalContext"
import getIconComponent from "../../utils/getIconComponent"
import FormularioPlanServicio from "../componente/FormularioPlanServicio"

const theme = createTheme({
  palette: {
    primary: { main: "#196C87" },
    secondary: { main: "#2E7D32" },
  },
})

const EditarPlanServicio = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { selectedMenuInfo } = useContext(GlobalContext)
  const formRef = useRef()

  const rowData = location.state || {}

  const { mutateAsync: SaveEdicion, isPending: isSaving } = useMutation({
    queryKey: ["isEditingPlanServicio"],
    fn: async (data) => {
      const response = await api.post("/PlanesServicios/editarPlanesServicios", data)
      return response.data
    },
    showError: "modal",
    showSuccess: "toast",
    onSuccess: () => navigate(-1),
  })

  const ejecutarAction = selectedMenuInfo?.data?.barraAcciones?.find((action) => action?.acccaption === "EJECUTAR")

  const handleSubmit = async (formData) => {
    await SaveEdicion(formData)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
      <ThemeProvider theme={theme}>
        <Header />
        <div className="main main-app p-3 p-lg-4">
          <BackIcon />

          <Box sx={{ mb: 2 }}>
            {ejecutarAction && (
              <Tooltip title={ejecutarAction.acccaption}>
                <IconButton
                  onClick={() => formRef.current?.handleSubmit()}
                  disabled={isSaving}
                  sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1 }}
                >
                  {getIconComponent(ejecutarAction.accnameicono, ejecutarAction.acctipoico)}
                </IconButton>
              </Tooltip>
            )}
          </Box>

          <div style={{ textAlign: "center", fontSize: "25px", mb: 3 }}>
            <b>Editar Plan de Servicio</b>
          </div>

          <CustomBackdrop isLoading={isSaving} />

          <FormularioPlanServicio
            ref={formRef}
            initialData={rowData}
            isLoading={isSaving}
            onSubmit={handleSubmit}
            modo="editar"
          />
        </div>
      </ThemeProvider>
    </LocalizationProvider>
  )
}

export default EditarPlanServicio
